import type { VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { badgeVariants } from './Badge.variants';

export interface BadgeProps
  extends ComponentPropsWithRef<'span'>,
    VariantProps<typeof badgeVariants> {}

/** Etykieta statusu — „Dodany”, „Open”, „LIVE”, numer rozstawienia. */
export function Badge({ className, tone, size, shape, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone, size, shape }), className)} {...props} />;
}
